import { jsxs, jsx } from "react/jsx-runtime";
import { Box, Heading, Text, List, Button } from "@zillow/constellation-10";
const SuccessState = ({
  referenceNumber,
  onSubmitAnother
}) => {
  return /* @__PURE__ */ jsxs(Box, { css: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "layout.looser",
    backgroundColor: "bg.neutral",
    borderRadius: "500",
    boxShadow: "shadows.lg",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch"
  }, children: [
    /* @__PURE__ */ jsx(Heading, { level: 2, textStyle: "heading-sm", css: {
      textAlign: "center",
      marginBottom: "loose",
      color: "text.neutral",
      fontFamily: "ui"
    }, children: "Report submitted successfully" }),
    /* @__PURE__ */ jsx(Text, { textStyle: "body", color: "text.subtle", css: {
      textAlign: "center",
      marginBottom: "loose"
    }, children: "Thank you for helping ensure all consumers have fair access to listings. Our team will review the information provided." }),
    /* @__PURE__ */ jsxs(Box, { css: {
      backgroundColor: "gray.50",
      borderRadius: "300",
      padding: "loose",
      marginBottom: "loose",
      textAlign: "center"
    }, children: [
      /* @__PURE__ */ jsx(Text, { asChild: true, textStyle: "body", color: "text.neutral", children: /* @__PURE__ */ jsx("p", { children: "Your report reference number:" }) }),
      /* @__PURE__ */ jsx(Text, { textStyle: "body-bold", css: {
        marginTop: "tighter",
        color: "text.link.default"
      }, children: referenceNumber })
    ] }),
    /* @__PURE__ */ jsxs(Box, { css: {
      backgroundColor: "blue.50",
      borderRadius: "300",
      padding: "loose",
      marginBottom: "loose"
    }, children: [
      /* @__PURE__ */ jsx(Heading, { level: 3, textStyle: "heading-xs", css: {
        marginBottom: "tighter",
        color: "text.neutral"
      }, children: "What happens next?" }),
      /* @__PURE__ */ jsxs(List.Root, { appearance: "bullet", children: [
        /* @__PURE__ */ jsx(List.Item, { children: "Our team will review your report and the documentation provided to us" }),
        /* @__PURE__ */ jsx(List.Item, { children: "We'll investigate whether the listing is being publicly marketed but not available on MLS, Zillow or other platforms" }),
        /* @__PURE__ */ jsx(List.Item, { children: "If the violation is confirmed, we'll take appropriate action according to our listing access standards" }),
        /* @__PURE__ */ jsx(List.Item, { children: "Together, we're ensuring all consumers have fair access to real estate information" })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Box, { css: {
      display: "flex",
      justifyContent: "center"
    }, children: /* @__PURE__ */ jsx(Button, { tone: "brand", emphasis: "filled", size: "lg", onClick: onSubmitAnother, children: "Submit another report" }) })
  ] });
};
export {
  SuccessState as default
};
